import React from 'react';

const MakeAdmin = () => {
    return (
        <div>
            
        </div>
    );
};

export default MakeAdmin;